
export const SalesDirectorDashboardPermissions = {
    AccountsDashboard: {
    permissionsId:'198c1f66-c99f-42bd-1cd2-08dabfc53c80',
    permissionsName:'Sales Director Dashboard',
    componentsId:null,
    components:null
  }
  } ;
  